import { Injectable, inject } from "@angular/core";
import { catchError, filter, finalize, map, switchMap, tap } from "rxjs/operators";
import { EMPTY, Observable } from "rxjs";
import { Store } from "@ngrx/store";

import { AWSHttpClient } from "@intocare-medapp/aws/http";

import { BriefingHistoryActions, Model } from "../../shared";
import { FilterPageOptionEnum } from "../../shared/enums";
import { ApplicationState, Briefing, HistoryEvent } from "../../shared/types";
import { FilterModel } from "../../filter/filter.model";
import { BriefingFilterService } from "../util/briefing-filter.service";

@Injectable()
export class BriefingHistoryModel extends Model {
	private readonly http = inject(AWSHttpClient);
	private readonly store = inject<Store<ApplicationState>>(Store);
	private readonly briefingFilterService = inject(BriefingFilterService);
	private readonly filterModel = inject(FilterModel);

	private readonly briefingHistory$ = this.store
		.select((state) => state.data.briefingHistory.data)
		.pipe(
			filter((data) => !!(data && data.items)),
			map(({ items }) => items),
		);

	filter$ = this.briefingFilterService.filter$;
	loading$ = this.store.select((state) => state.data.briefingHistory.ui.loading);
	filteredBriefingHistory$: Observable<Briefing[]> = this.briefingHistory$.pipe(
		// @ts-expect-error TS2345
		switchMap((briefings) => this.briefingFilterService.getFilteredBriefings(briefings)),
	);

	search(text: string) {
		this.briefingFilterService.search(text);
	}

	loadBriefingHistory() {
		this.store.dispatch(BriefingHistoryActions.loading(true));

		return this.http.get<{ history: HistoryEvent[] }>("briefing/v2").pipe(
			map(({ history }) => history),
			catchError(() => EMPTY),
			tap((result) => this.store.dispatch(BriefingHistoryActions.set(result))),
			finalize(() => this.store.dispatch(BriefingHistoryActions.loading(false))),
		);
	}

	selectFilter(filterId: FilterPageOptionEnum) {
		this.filterModel.selectFilter(filterId);
	}
}
